import { connect } from "react-redux";
import IssueListItem from "./IssueListItem";
import { Creators } from "../../../../reducer";

export default connect(null, dispatch => ({
  onDelete: (issueKey, customerKey) =>
    dispatch(Creators.deleteIssue(issueKey, customerKey))
}))(IssueListItem);



// WEBPACK FOOTER //
// ./src/customer/components/EditCustomer/IssueList/IssueListItem/index.js